import React, { useEffect, useState } from "react";
import SettingsEmptyState from '../settings/SettingsEmptyState';
import useFetch from "../../hooks/useFetch";
import useDelete from "../../hooks/useDelete";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import { MwButton, MwSpinnerButton, ConfirmDelete } from "../ui";
import TaxListItem from "./Vat_Components/TaxListItem";
import AddEditTaxModal from "./Vat_Components/AddEditTaxModal";
import { useCurrent } from "../../hooks";

const VatPage = () => {
  const { t, i18n } = useTranslation("global");
  const isRTL = i18n.language === "ar";
  const lang = i18n.language;

  const [modalOpen, setModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [mode, setMode] = useState("add");
  const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();
  const baseUrl = `${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/taxes/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
  const [currentUrl, setCurrentUrl] = useState(baseUrl);

  const { data, loading, refreshHandler } = useFetch(currentUrl);
  const { deleteItem, loading: deleteLoading } = useDelete();

  useEffect(() => {
    setCurrentUrl(baseUrl);
  }, [currentTenantId, currentCompanyId, currentBranchId]);

  const addHandler = () => {
    setMode("add");
    setSelectedItemId(null);
    setModalOpen(true);
  };

  const editHandler = (id) => {
    setMode("edit");
    setSelectedItemId(id);
    setModalOpen(true);
  };

  const deleteHandler = async () => {
    const deleteUrl = `${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/taxes/delete/${selectedItemId}`;
    await deleteItem(deleteUrl);
    refreshHandler();
    setDeleteModalOpen(false);
  };

  const paginateHandler = (url) => {
    setCurrentUrl(url.replace("http", "https"));
  };

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-4">
        <p className="font-bold text-gray-500 text-sm">{t("vat.title")}</p>
        <MwButton
          onClick={addHandler}
          className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
          type="saveBtn"
        >
          {t("vat.add")}
        </MwButton>
      </div>

      <div className="flex-1 flex flex-col">
        {loading && <MwSpinnerButton withLabel={false} />}
        {data?.data?.length > 0 ? (
          <div className="w-full text-xs rounded-xl bg-white border border-slate-200 text-slate-600">
            <div className="flex gap-2 font-bold px-3 py-2 rounded-t-xl justify-between items-center bg-slate-100 text-slate-600">
              <div className="w-16 text-center">#</div>
              <div className="flex-1">{t("vat.name")}</div>
              <div className="w-36 text-center">{t("vat.value")}</div>
              <div className="w-36 text-center">{t("vat.taxType", "نوع الضريبة")}</div>
              <div className="w-48 text-center">{t("vat.accountNumber", "رقم الحساب")}</div>
              <div className="w-36 text-center">{t("vat.status")}</div>
              <div className="w-36 text-center">{t("vat.actions")}</div>
            </div>
            {data?.data.map((item, index) => (
              <TaxListItem
                key={item.id}
                index={index}
                item={item}
                lang={lang}
                isRTL={isRTL}
                editHandler={editHandler}
                setSelectedItemId={setSelectedItemId}
                setDeleteModalOpen={setDeleteModalOpen}
              />
            ))}
            {data?.links && data?.links.length > 0 && (
              <div
                id="dataLinks"
                className="list-none flex gap-3 border-t py-3 px-5 cursor-default"
              >
                {data?.data?.length > 3 &&
                  data?.links.map((item, i) => (
                    <li
                      key={i}
                      className="hover:font-bold"
                      onClick={() => item?.url && paginateHandler(item?.url)}
                    >
                      {parse(item?.label)}
                    </li>
                  ))}
              </div>
            )}
          </div>
        ) : (
          <SettingsEmptyState msg={t("vat.noData")} />
        )}
      </div>

      {modalOpen && (
        <AddEditTaxModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          mode={mode}
          itemId={selectedItemId}
          onSuccess={refreshHandler}
        />
      )}

      <ConfirmDelete
        onShow={deleteModalOpen}
        setOnShow={setDeleteModalOpen}
        title={t("vat.deleteConfirmTitle")}
        msg={t("vat.deleteConfirmMessage")}
        onDeleteHandler={deleteHandler}
        loading={deleteLoading}
      />
    </div>
  );
};

export default VatPage;
